/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Redeem_HintInputs */

const en_us2_invite_redeem_hint = /** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It counts in your account's first 14 days.`)
};

const pt_br2_invite_redeem_hint = /** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vale nos primeiros 14 dias da sua conta.`)
};

const pt_pt2_invite_redeem_hint = /** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vale nos primeiros 14 dias da sua conta.`)
};

/** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */
const es_419_invite_redeem_hint = en_us2_invite_redeem_hint;

/** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */
const fr_fr2_invite_redeem_hint = en_us2_invite_redeem_hint;

/** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */
const de_de2_invite_redeem_hint = en_us2_invite_redeem_hint;

/** @type {(inputs: Invite_Redeem_HintInputs) => LocalizedString} */
const it_it2_invite_redeem_hint = en_us2_invite_redeem_hint;

/**
* | output |
* | --- |
* | "It counts in your account's first 14 days." |
*
* @param {Invite_Redeem_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_redeem_hint = /** @type {((inputs?: Invite_Redeem_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Redeem_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_redeem_hint(inputs)
	if (locale === "es-419") return es_419_invite_redeem_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_redeem_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_redeem_hint(inputs)
	if (locale === "de-DE") return de_de2_invite_redeem_hint(inputs)
	if (locale === "it-IT") return it_it2_invite_redeem_hint(inputs)
	return en_us2_invite_redeem_hint(inputs)
});
export { invite_redeem_hint as "invite.redeem_hint" }